import { CloseOutlineIcon } from '@carboncopyco/icons';
import { ChampagneBigIllustration } from '@carboncopyco/illustrations';
import { Button, LoadingDots, TextBase, TextSubHeader } from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';
import type { MouseEvent, ReactNode } from 'react';

export interface RecordingSavedProps {
  onDismiss?: () => void;
  previewSavedRecording?: () => void;
  handleRedirectToEditor: (e?: MouseEvent) => any;
  handleRedirectToDashboard: (e?: MouseEvent) => any;
  isLoading?: boolean;
  timeLimitText?: ReactNode;
}

export const RecordingSaved = ({
  onDismiss,
  previewSavedRecording,
  handleRedirectToEditor,
  handleRedirectToDashboard,
  isLoading,
  timeLimitText,
}: RecordingSavedProps) => {
  const [disableEditorButton, setDisableEditorButton] = useBoolean();
  const [loader, setLoader] = useBoolean();

  return (
    <div className="pb-2">
      <div className="flex flex-col justify-center items-center">
        <button
          className="mt-2 mr-2 pt-3 px-3 pr-3 pb-2 self-end"
          style={{ font: 'inherit' }}
          onClick={onDismiss}
        >
          <CloseOutlineIcon size={20} />
        </button>
        <ChampagneBigIllustration />
        <div>
          <div className="mt-14 mb-2 flex justify-center">
            <TextSubHeader
              color="text-ds-natural-600"
              label="Your clone is saved!"
            />
          </div>

          {timeLimitText ? (
            <div className="flex items-center gap-1.5">{timeLimitText}</div>
          ) : (
            <div>
              <TextBase
                color="text-ds-natural-400"
                label="Preview your clone or customize it in the demo editor."
              />
            </div>
          )}
        </div>
        <div className="flex mt-12 mr-5 mb-3 w-full justify-end">
          {!loader && !isLoading ? (
            <>
              <div>
                <Button
                  link
                  onClick={handleRedirectToDashboard}
                  label="Create new clone"
                />
              </div>
              <div className="mx-2">
                <Button
                  onClick={previewSavedRecording}
                  secondary
                  label="Preview"
                />
              </div>
              <div className="mr-2.5">
                <Button
                  disabled={disableEditorButton}
                  onClick={() => {
                    setDisableEditorButton.setTrue();
                    setLoader.setTrue();
                    handleRedirectToEditor();
                  }}
                  label="Open in editor"
                />
              </div>
            </>
          ) : (
            <div className="justify-center flex m-auto">
              <LoadingDots />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
